import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import CargomaticCard from '../../v2/card';

class NotificationGroup extends Component {
  getHeading = (category) => {
    const { t } = this.props;

    const headings = {
      all: t('ALL_SHIPMENT_TYPES'),
      shipments: t('SHORTHAUL_SHIPMENTS'),
      billing: t('SHORTHAUL_BILLING'),
      drayage: t('DRAYAGE_SHIPMENTS_&_BILLING'),
      appointment: t('APPOINTMENTS'),
    };

    return headings[category] || category;
  };
  render() {
    const { category } = this.props;

    return (
      <div className="mb-6">
        <CargomaticCard
          header={() => <h3 className="my-0">{this.getHeading(category)}</h3>}
        >
          <div className="notification-types">{this.props.children}</div>
        </CargomaticCard>
      </div>
    );
  }
}

NotificationGroup.propTypes = {
  category: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withTranslation()(NotificationGroup);
